import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import { lzIsArray, lzIsNull, lzIsString } from '../../../../services/LzType';
import LzFormFieldBase from './_base';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

class LzFormFieldSelect extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            options: props.options ? props.options : [],
            value: typeof props.value === 'undefined' || lzIsNull(props.value) ? '' : props.value,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { options, value } = this.props;

        // If value changed then apply it to state
        let changed = false;
        let states = {};
        if (typeof value !== 'undefined' && value !== prevProps.value) {
            states.value = value;
            changed = true;
        }
        if (typeof options !== 'undefined' && options !== prevProps.options) {
            states.options = options;
            changed = true;
        }
        if (changed) {
            this.setState(states);
        }
    }

    onChange(val) {
        const { name, onChange } = this.props;

        this.setState({ value: val });

        if (onChange) {
            onChange(name, val);
        }
    }

    render() {
        const { options, value } = this.state;
        const {
            fluid, required, icon, className, style, id, name, label, placeholder, disabled,
            hintText, noFirstOption, firstOptionValue, firstOptionText, disabledEvaluator,
            variant, margin, noHint
        } = this.props;

        const theName = name ? name : '';
        const theId = id ? id : 'id_' + theName;

        const isReady = lzIsArray(options);// && value; if this is done then Select does not show if value is 0 or empty

        // console.log('FIELD SELECT', theId, name, label, value, options);

        return (
            <LzFormFieldBase
                labelShrink
                id={theId}
                fluid={fluid}
                required={required}
                disabled={disabled}
                icon={icon}
                name={name}
                label={label}
                placeholder={placeholder}
                hintText={noHint ? false : hintText || placeholder}
            >

                {!isReady &&
                    <div className='lz-select'>
                        {'loading' === options && <CircularProgress />}
                        {lzIsString(options) && <Alert variant="filled" color="warning">{options}</Alert>}
                    </div>
                }

                {isReady &&
                    <Select
                        required={required}
                        fullWidth={fluid}
                        disabled={disabled}
                        name={name || ''}
                        className={'lz-select ' + (className ? className : '')}
                        style={style || {}}
                        placeholder={placeholder || ''}
                        value={value}
                        variant={variant}
                        margin={margin}
                        onChange={(evt) => this.onChange(evt.target.value)}
                    >
                        {!noFirstOption && <MenuItem value={typeof firstOptionValue === 'undefined' ? 0 : firstOptionValue}>{firstOptionText || '- select any -'}</MenuItem>}
                        {options.map((option, dex) =>
                            <MenuItem
                                key={'opt-' + dex}
                                value={option.value}
                                disabled={
                                    value !== option.value &&               // if not already selected
                                        disabledEvaluator                   // and the evaluate is provided
                                        ?
                                        disabledEvaluator(option, value)    // then use it
                                        :
                                        false                               // else assume its NOT disabled
                                }
                            >{option.text}</MenuItem>
                        )}
                    </Select>
                }

            </LzFormFieldBase>
        );
    }

}

export default LzFormFieldSelect;
